import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const entHorarioClaseBloquesApi = `${baseUrl}/entidad-horario-clase-bloques`;

export const allEntHorBloquesService = async (params) => {
  const res = await axios.get(entHorarioClaseBloquesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEntHorBloquesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${entHorarioClaseBloquesApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(entHorarioClaseBloquesApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneEntHorBloquesService = async (id) => {
  const res = await axios.get(`${entHorarioClaseBloquesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEntHorBloquesService = async (id) => {
  const res = await axios.delete(`${entHorarioClaseBloquesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
